export enum ErrorType {
	Unknown = 0,
	ApiNotAvailable = 1,
	PlayerIdMissing = 2,
	PlayerNotFound = 3,
	SignRequestFailed = 4,
	SceneNotFound = 5,
	Unauthorized = 6,
	Expired = 7,
}
